import { createSlice } from '@reduxjs/toolkit';

import { getCartItemsTotalCountByCurrentUser } from 'Feature/Orders/Common/Actions/Thunks/getCartItemsTotalCountByCurrentUser';

import ILandingMainPageState from './model';

const initialState: ILandingMainPageState = {
  userProfile: {
    isOpen: false,
  },
  userCartItemsTotalCount: {
    loading: false,
    data: null,
  },
  changeIconColor: 0,
};

export const landingMainPageSlice = createSlice({
  name: 'landing/MainPage',
  initialState,
  reducers: {
    setUserProfileMenu: (state) => {
      state.userProfile.isOpen = !state.userProfile.isOpen;
    },
    setChangeIconColor: (state, action) => {
      state.changeIconColor = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCartItemsTotalCountByCurrentUser.pending, (state) => {
        state.userCartItemsTotalCount.loading = true;
      })
      .addCase(getCartItemsTotalCountByCurrentUser.fulfilled, (state, action) => {
        state.userCartItemsTotalCount.loading = false;
        if (action.payload !== undefined) {
          state.userCartItemsTotalCount.data = action.payload;
        }

        return state;
      })
      .addCase(getCartItemsTotalCountByCurrentUser.rejected, (state) => {
        state.userCartItemsTotalCount.loading = false;
      });
  },
});
export const { setUserProfileMenu, setChangeIconColor } = landingMainPageSlice.actions;

export default landingMainPageSlice.reducer;
